import { useQuery } from '@tanstack/react-query';
import { minutesToMilliseconds } from 'date-fns';

import { api } from '@api';
import { Incident } from '@models/Incident';

/** Utility hook to fetch messages related to an incident */
export const useIncidentMessages = (incidentId: Incident['incidentId']) => {
  const { data: messagesData, ...rest } = useQuery(
    ['incident-messages', incidentId],
    () => api.incidents.fetchIncidentMessages(incidentId ?? ''),
    {
      enabled: !!incidentId,
      // Refresh periodically so that new messages can be seen as soon as possible
      refetchInterval: minutesToMilliseconds(1),
      staleTime: minutesToMilliseconds(1),
      refetchOnMount: 'always',
    }
  );

  return { messages: messagesData?.data.incidentPosts, ...rest };
};
